// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"9":"b1625e81","25":"c15bebac","66":"78c1bd33","91":"892f5904","158":"386d0540","161":"edbf74ae","358":"47539a98","471":"8a4f7e9e","500":"fb23cee5","506":"c9a7e139","588":"9de7bc63","622":"ad6df5cf","656":"5dd36630","743":"00983bbf","985":"40d1a1c3"}[chunkId] + ".js";
};